// Cart Drawer Recommendation Component
console.log('Cart Drawer Recommendation script loaded. ReadyState:', document.readyState);

function attemptInit() {
    console.log('Attempting to init Cart Drawer Recommendations...');
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            console.log('DOM Content Loaded event fired');
            initCartDrawerObserver();
        });
    } else {
        console.log('DOM already loaded, initializing immediately');
        initCartDrawerObserver();
    }
}

attemptInit();

function initCartDrawerObserver() {
  const cartDrawer = document.getElementById('cartDrawer');
  if (cartDrawer) {
    console.log('cartDrawer element found', cartDrawer);
    
    let debounceTimer;
    const debouncedLoad = () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            loadCartRecommendations();
        }, 300);
    };

    const observer = new MutationObserver((mutations) => {
      let shouldLoad = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
           console.log('cartDrawer class changed:', cartDrawer.className);
           shouldLoad = true;
        } else if (mutation.type === 'childList') {
           const recommendationContainer = document.querySelector('.js-cart-recommendation-drawer');
           if (recommendationContainer && !recommendationContainer.hasAttribute('data-loaded')) {
               console.log('Recommendation container found and needs loading (via childList mutation)');
               shouldLoad = true;
           }
        }
      });
      
      if (shouldLoad) {
          debouncedLoad();
      }
    });

    observer.observe(cartDrawer, { 
        attributes: true, 
        attributeFilter: ['class'],
        childList: true,
        subtree: true 
    });
    
    const recommendationContainer = document.querySelector('.js-cart-recommendation-drawer');
    if (recommendationContainer && !recommendationContainer.hasAttribute('data-loaded')) {
        loadCartRecommendations();
    }
    
  } else {
      console.warn('cartDrawer element NOT found');
  }
}

window.reloadCartRecommendations = loadCartRecommendations;

let currentRecommendationIndex = 0;

async function fetchBestSelling(container) {
    console.log('Fetching best selling...');
    try {
        let bestSellingUrl = '/collections/all?sort_by=best-selling&section_id=cart-drawer-recommendation';
        let bestSellingResponse = await fetch(bestSellingUrl);
        
        if (!bestSellingResponse.ok) {
             console.log('collections/all failed, trying /collections...');
             bestSellingUrl = '/collections?section_id=cart-drawer-recommendation';
             bestSellingResponse = await fetch(bestSellingUrl);
        }

        if (bestSellingResponse.ok) {
            const bestSellingHtml = await bestSellingResponse.text();
            // Debug the returned HTML to ensure it's not an error page or empty
            if (bestSellingHtml.includes('<!doctype html>') || bestSellingHtml.includes('<html')) {
                // If we got a full page instead of a section, it might mean section rendering failed
                console.warn('Received full HTML page instead of section fragment');
            }

            const tempBestSellingDiv = document.createElement('div');
            tempBestSellingDiv.innerHTML = bestSellingHtml;
            const recommendationItems = tempBestSellingDiv.querySelectorAll('.cart-drawer__recommended-item[data-valid="true"]');
            
            console.log('Best selling items found: ' + recommendationItems.length);

            if (recommendationItems.length > 0) {
                 renderRecommendations(container, recommendationItems);
                 console.log('✅ Displaying: Best Selling Fallback Products');
                 return true;
            } else {
                console.warn('Best selling HTML returned no valid items');
                // Log more content to see debug comments
                console.log('HTML content preview:', bestSellingHtml.substring(0, 500));
            }
        } else {
            console.error('Best selling fetch failed', bestSellingResponse.status);
        }
    } catch (bsError) {
        console.error('Error fetching best selling:', bsError);
    }
    return false;
}

async function loadCartRecommendations() {
  console.log('loadCartRecommendations triggered');
  const container = document.querySelector('.js-cart-recommendation-drawer');
  if (!container) {
      console.log('Container .js-cart-recommendation-drawer not found, aborting');
      return;
  }
  
  if (container.hasAttribute('data-loaded') && container.children.length > 0) {
      console.log('Recommendations already loaded, skipping');
      return;
  }

  container.setAttribute('data-loaded', 'true');

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    console.log('Cart fetched:', cart);
    
    if (!cart.items || cart.items.length === 0) {
        console.log('Cart empty, fallback to best selling.');
        const success = await fetchBestSelling(container);
        if (!success) {
            const parent = container.closest('.popup_recommend');
            if(parent) parent.style.display = 'none';
        }
        return;
    }

    const firstProductId = cart.items[0].product_id;
    const secondProductId = cart.items.length > 1 ? cart.items[1].product_id : null;
    console.log('Products for recommendation:', firstProductId, secondProductId);

    const recommendationsUrl = (window.routes && window.routes.product_recommendations_url) ? window.routes.product_recommendations_url : '/recommendations/products';
    
    const promises = [];
    
    promises.push(
        fetch(`${recommendationsUrl}?section_id=cart-drawer-recommendation&product_id=${firstProductId}&limit=4`)
        .then(r => r.ok ? r.text() : null)
        .catch(e => null)
    );
    
    if (secondProductId) {
        promises.push(
            fetch(`${recommendationsUrl}?section_id=cart-drawer-recommendation&product_id=${secondProductId}&limit=4`)
            .then(r => r.ok ? r.text() : null)
            .catch(e => null)
        );
    }
    
    const results = await Promise.all(promises);
    
    const itemsLists = results.map(html => {
        if (!html) return [];
        const div = document.createElement('div');
        div.innerHTML = html;
        return Array.from(div.querySelectorAll('.cart-drawer__recommended-item[data-valid="true"]'));
    });
    
    const list1 = itemsLists[0] || [];
    const list2 = itemsLists[1] || [];
    console.log('Recommendations found: List1=' + list1.length + ', List2=' + list2.length);
    
    const combinedItems = [];
    const maxLen = Math.max(list1.length, list2.length);
    const seenProductIds = new Set();
    
    cart.items.forEach(item => seenProductIds.add(String(item.product_id)));

    function processItem(item) {
        const btn = item.querySelector('.js-add-to-cart-recommended');
        const pId = btn ? btn.getAttribute('data-product-id') : null;
        
        if (pId) {
            if (!seenProductIds.has(pId)) {
                combinedItems.push(item);
                seenProductIds.add(pId);
            }
        } else {
             combinedItems.push(item);
        }
    }

    for (let i = 0; i < maxLen; i++) {
        if (i < list1.length) processItem(list1[i]);
        if (i < list2.length) processItem(list2[i]);
    }
    
    console.log('Total unique combined items: ' + combinedItems.length);

    if (combinedItems.length > 0) {
      console.log('✅ Displaying: Search & Discovery Recommendations');
      renderRecommendations(container, combinedItems);
    } else {
       console.log('No valid recommendations found, fetching best selling...');
       const success = await fetchBestSelling(container);
       if (!success) {
           const parent = container.closest('.popup_recommend');
           if(parent) parent.style.display = 'none';
       }
    }

  } catch (error) {
    console.error('Error loading recommendations:', error);
    fetchBestSelling(container);
  }
}

function renderRecommendations(container, recommendationItems) {
      container.innerHTML = '';
      recommendationItems.forEach((item, index) => {
        item.style.display = index === 0 ? 'flex' : 'none';
        container.appendChild(item);
      });
      
      const parent = container.closest('.popup_recommend');
      if(parent) parent.style.display = 'block';

      currentRecommendationIndex = 0;
      setupNavigation();
      setupRecommendedAddToCart();
      setupSwatchInteractions();
}

function setupSwatchInteractions() {
  const swatches = document.querySelectorAll('.cart-drawer__recommended-swatch');
  
  swatches.forEach(swatch => {
    swatch.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const item = swatch.closest('.cart-drawer__recommended-item');
      if (!item) return;

      // 1. Update active class
      const siblings = item.querySelectorAll('.cart-drawer__recommended-swatch');
      siblings.forEach(s => s.classList.remove('is-selected'));
      swatch.classList.add('is-selected');

      // 2. Update Image
      const imageUrl = swatch.dataset.imageUrl;
      if (imageUrl) {
          const img = item.querySelector('.cart-drawer__recommended-item-image img');
          if (img) {
              img.src = imageUrl;
              img.srcset = ''; // Clear srcset to force src usage or update it if possible
          }
      }

      // 3. Update Add Button Variant ID
      const variantId = swatch.dataset.variantId;
      if (variantId) {
          const btn = item.querySelector('.js-add-to-cart-recommended');
          if (btn) btn.dataset.variantId = variantId;
      }
    });
  });
}

function setupNavigation() {
  const prevBtn = document.querySelector('.js-recommended-prev');
  const nextBtn = document.querySelector('.js-recommended-next');
  
  if (prevBtn) {
      const newPrev = prevBtn.cloneNode(true);
      prevBtn.parentNode.replaceChild(newPrev, prevBtn);
      newPrev.addEventListener('click', () => navigateRecommendations(-1));
  }
  if (nextBtn) {
      const newNext = nextBtn.cloneNode(true);
      nextBtn.parentNode.replaceChild(newNext, nextBtn);
      newNext.addEventListener('click', () => navigateRecommendations(1));
  }
}

function navigateRecommendations(direction) {
  const items = document.querySelectorAll('.cart-drawer__recommended-item');
  if (!items.length) return;

  items[currentRecommendationIndex].style.display = 'none';
  currentRecommendationIndex = (currentRecommendationIndex + direction + items.length) % items.length;
  items[currentRecommendationIndex].style.display = 'flex';
}

function setupRecommendedAddToCart() {
  const addButtons = document.querySelectorAll('.js-add-to-cart-recommended');
  
  addButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      try {
        const formData = {
          items: [{
            id: variantId,
            quantity: 1
          }]
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });

        if (response.ok) {
           window.location.reload();
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    });
  });
}
